import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE: {
  data: any;
  expiryDate: any;
  selectedUserIds: string[];
  selectedRoleIds: string[];
  selectedList: any;
  activeUserId: string;
  successList: [];
  removeSuccessList: [];
  updateSuccessList: [];
  failureList: [];
} = {
  data: {},
  expiryDate: "",
  selectedUserIds: [],
  selectedRoleIds: [],
  selectedList: [],
  activeUserId: "",
  successList: [],
  removeSuccessList: [],
  updateSuccessList: [],
  failureList: []
};

export const AssignEditRoleSLice = createSlice({
  name: "AssignEditRoleSLice",
  initialState: INIT_STATE,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setExpiryDate(state, action) {
      state.expiryDate = action.payload;
    },
    setSelectedUserIds(state, action) {
      state.selectedUserIds = action.payload;
    },
    setSelectedList: (state, action) => {
      state.selectedList = action.payload;
    },
    setSelectedRoleIds: (state, action) => {
      state.selectedRoleIds = action.payload;
    },
    setSuccessList: (state, action) => {
      state.successList = action.payload;
    },
    setRemoveSuccessList: (state, action) => {
      state.removeSuccessList = action.payload;
    },
    setUpdateSuccessList: (state, action) => {
      state.updateSuccessList = action.payload;
    },
    setFailureList: (state, action) => {
      state.failureList = action.payload;
    },
    setActiveUserId: (state, action) => {
      state.activeUserId = action.payload;
    },
    addSelectedUser(state, action) {
      const newIds = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      const unique = new Set([...state.selectedUserIds, ...newIds]);
      state.selectedUserIds = Array.from(unique);
    },
    removeSelectedUser(state, action) {
      const idsToRemove = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      state.selectedUserIds = state.selectedUserIds.filter(
        (id) => !idsToRemove.includes(id)
      );
    },
    clearSelection: (state) => {
      state.selectedList = [];
      state.selectedRoleIds = [];
      state.successList = [];
      state.removeSuccessList = [];
      state.updateSuccessList = [];
      state.failureList = [];
      state.expiryDate = {};
    }
  }
});

export default AssignEditRoleSLice;

export const AssignEditRoleSLiceActions = AssignEditRoleSLice.actions;
